import "./assets/css/main.css";
import "./assets/css/mapboxgl.css";
import "./assets/css/vuetify.css";
import "vue-snotify/styles/simple.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "vuetify/dist/vuetify.min.css";

import InfiniteLoading from "vue-infinite-loading";
import Snotify from "vue-snotify";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./registerServiceWorker";

import ECharts from "vue-echarts";
import InfiniteScrollLoader from "@/components/common/InfiniteScrollLoader";
import modal from "vue-js-modal";

Vue.use(Snotify, {
  global: {
    maxOnScreen: 25,
    maxAtPosition: 25,
  },
});
Vue.component("v-chart", ECharts);

Vue.use(Vuetify, {
  iconfont: "fa",
});
Vue.use(modal);

// Docs: https://peachscript.github.io/vue-infinite-loading/guide/configure-plugin-opts.html#props-settings
Vue.use(InfiniteLoading, {
  slots: {
    spinner: InfiniteScrollLoader,
    noMore: "",
    noResults: "",
  },
  props: {
    direction: "bottom",
  },
});

import numeral from "numeral";

Vue.filter("filterFormatNumber", function (value) {
  return numeral(value).format("0,0");
});

import Analytics from "@/mixins/analytics";
import FeatureLock from "@/mixins/featureLock";
import CopyToClipboard from "@/mixins/copyToClipboard";
import AppRequirementCheck from "@/mixins/appRequirementCheck";
import MapFeature from "@/mixins/mapFeature";
import vuetify from "./plugins/vuetify";
import eventListener from "./plugins/eventListener";

Vue.use(eventListener);

Vue.mixin(Analytics);
Vue.mixin(FeatureLock);
Vue.mixin(CopyToClipboard);
Vue.mixin(AppRequirementCheck);
Vue.mixin(MapFeature);

Vue.config.performance = process.env.NODE_ENV !== "production";
Vue.config.productionTip = false;

import { Auth0Plugin, getAuthTenantConfig } from "@/common/authenticate";

let authConfig = getAuthTenantConfig();

if (authConfig) {
  Vue.use(Auth0Plugin, {
    domain: authConfig.domain,
    clientId: authConfig.clientId,
    onRedirectCallback: (appState) => {
      router.push(
        appState && appState.targetUrl
          ? appState.targetUrl
          : window.location.pathname
      );
    },
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
